import React, { useState } from "react";
import './LegalPages.scss';


const RequestData: React.FC = () => {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Ici tu peux soit envoyer un email, soit faire un POST vers ton backend (idéal)
    setSent(true);
  };

  return (
    <div className="legal-page">
      <h1>Demander ou supprimer mes données</h1>
      {sent ? (
        <div style={{ color: "green", margin: "32px 0" }}>
          Votre demande a bien été envoyée. Nous vous répondrons dans les meilleurs délais (sous 30 jours).
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="legal-form">
          <label htmlFor="email">Votre adresse e-mail :</label>
          <input
            type="email"
            name="email"
            id="email"
            required
            placeholder="nom@exemple.com"
            style={{ margin: "12px 0", padding: "8px", width: "100%" }}
          />
          <label htmlFor="type">Type de demande :</label>
          <select id="type" name="type" style={{ margin: "12px 0", padding: "8px", width: "100%" }}>
            <option value="access">Accéder à mes données</option>
            <option value="rectify">Rectifier mes données</option>
            <option value="delete">Supprimer mes données</option>
          </select>
          <label htmlFor="message">Informations complémentaires (facultatif) :</label>
          <textarea
            name="message"
            id="message"
            rows={3}
            style={{ margin: "12px 0", padding: "8px", width: "100%" }}
          />
          <button type="submit" style={{ background: "#ff8800", color: "#fff", border: "none", padding: "12px 32px", borderRadius: "5px", cursor: "pointer" }}>
            Envoyer ma demande
          </button>
        </form>
      )}

      <p style={{ marginTop: "32px", color: "#999" }}>
        Conformément au RGPD, vous pouvez exercer vos droits d’accès, de rectification, ou de suppression de vos données. Pour toute question : <a href="mailto:contact@reviewboost.ai">contact@reviewboost.ai</a>
      </p>
    </div>
  );
};

export default RequestData;
